var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGnavSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6rwck95ega"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1974H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dtkx9aj3db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.37 15.029a.782.782 0 0 1 .751.215l8.094 8.415a.781.781 0 0 1-.023 1.109.781.781 0 0 1-1.11-.023l-8.086-8.415a.782.782 0 0 1 .374-1.301zM2.684 2.33a8.672 8.672 0 0 1 12.14.305h-.015a8.453 8.453 0 0 1-.32 12.04 8.656 8.656 0 0 1-12.141-.321A8.367 8.367 0 0 1 .004 8.276a8.453 8.453 0 0 1 2.68-5.946zM13.7 3.721a7.094 7.094 0 0 0-9.946-.266 6.898 6.898 0 0 0-.265 9.813 7.086 7.086 0 0 0 9.945.305v-.04a6.89 6.89 0 0 0 .266-9.812z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vsk1ywdcec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0v25H0V0h25z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6rwck95ega)",
    transform: "translate(-1213 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dtkx9aj3db)",
    transform: "translate(1213.285 21.49)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vsk1ywdcec)",
    transform: "translate(-.285 -.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A3A",
    d: "M.285.013H24.72V25H.285V.013z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnavSearch);
export default __webpack_public_path__ + "static/media/icon-gnav-search.1e3fb7c177722568e5fdd8492a3daff5.svg";
export { ForwardRef as ReactComponent };